import React, { useState, useEffect } from "react";
import cn from "classnames";
import styles from "./Participants.module.sass";
import Card from "../../../../components/Card";
import Form from "../../../../components/Form";
import Table from "./Table";
import Icon from "../../../../components/Icon";

// Services
import { getAttendancesBySessionId, deleteAttendance } from "../../../../services/attendances.service";
import { showSuccess, showError } from "../../../../services/toast.service";

const SignaturesAndAbsences = ({ session, selectedAttendances, onSelectAttendance, onSelectAll }) => {
    const [search, setSearch] = useState("");
    const [attendances, setAttendances] = useState([]);
    const [filteredAttendances, setFilteredAttendances] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAttendances = async () => {
        if (!session || !session.id) return;
        try {
            setLoading(true);
            const attendancesData = await getAttendancesBySessionId(session.id);
            setAttendances(attendancesData);
            setFilteredAttendances(attendancesData);
        } catch (error) {
            console.error('Erreur lors de la récupération des attendances:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (session) {
            fetchAttendances();
        }
    }, [session]);

    const handleSelectAttendance = (attendanceId, isSelected) => {
        if (onSelectAttendance) {
            onSelectAttendance(attendanceId, isSelected);
        }
    };

    const handleSelectAll = (isSelected) => {
        if (onSelectAll) {
            const allAttendanceIds = filteredAttendances.map(attendance => attendance.id);
            onSelectAll(isSelected, allAttendanceIds);
        }
    };

    const handleEditAttendance = (attendance) => {
        // Pour l'instant, on peut juste afficher les détails ou rediriger vers la page étudiant
        console.log('Éditer attendance:', attendance);
        // TODO: Implémenter la redirection vers la page de détail de l'étudiant
    };

    const handleDeleteAttendance = async (attendanceId) => {
        try {
            await deleteAttendance(attendanceId);
            
            // Mettre à jour l'état local
            const remainingAttendances = attendances.filter(a => a.id !== attendanceId);
            setAttendances(remainingAttendances);
            setFilteredAttendances(remainingAttendances.filter(attendance => {
                if (!search.trim()) return true;
                const searchLower = search.toLowerCase();
                const participant = attendance.expand?.participant_id;
                if (!participant) return false;
                const fullName = `${participant.first_name} ${participant.last_name}`.toLowerCase();
                const email = (participant.email || '').toLowerCase();
                return fullName.includes(searchLower) || email.includes(searchLower);
            }));
            
            showSuccess('Attendance supprimée avec succès.');
        } catch (error) {
            showError('Erreur lors de la suppression de l\'attendance.');
            console.error(error);
        }
    };

    const handleSendSignatureInvitation = async (attendanceIds) => {
        try {
            // Cette fonction est maintenant gérée par le composant parent
            console.log('Envoi invitation pour:', attendanceIds);
            showSuccess(`Invitation de signature envoyée avec succès.`);
            
            // Rafraîchir les attendances pour voir les mises à jour
            await fetchAttendances();
        } catch (error) {
            console.error('Erreur lors de l\'envoi de l\'invitation:', error);
            showError(error.message || 'Erreur lors de l\'envoi de l\'invitation de signature.');
        }
    };


    // Fonction de recherche
    useEffect(() => {
        if (!search.trim()) {
            setFilteredAttendances(attendances);
        } else {
            const searchLower = search.toLowerCase();
            const filtered = attendances.filter(attendance => {
                const participant = attendance.expand?.participant_id;
                if (!participant) return false;
                const fullName = `${participant.first_name} ${participant.last_name}`.toLowerCase();
                const email = (participant.email || '').toLowerCase();
                return fullName.includes(searchLower) || email.includes(searchLower);
            });
            setFilteredAttendances(filtered);
        }
    }, [search, attendances]);

    const handleSubmit = (e) => {
        if (e) e.preventDefault();
        // filterTutors(search);
    };

    return (
        <>
            <Card
                className={styles.card}
                classCardHead={styles.head}
                title="Signatures & Absences"
                classTitle={cn("title-blue", styles.title)}
                head={
                    <>
                      <Form
                        className={styles.form}
                        value={search}
                        setValue={setSearch}
                        onSubmit={() => handleSubmit()}
                        placeholder="Rechercher par nom, prénom, email"
                        type="text"
                        name="search"
                        icon="search"
                      />
                    </>
                  }
                >
                <div className={styles.wrapper}>
                    {loading ? (
                        <div className={styles.loading}>
                            <div className="spinner-large" />
                        </div>
                    ) : filteredAttendances.length > 0 ? (
                        <Table
                            items={filteredAttendances}
                            selectedAttendances={selectedAttendances}
                            onSelectAttendance={handleSelectAttendance}
                            onSelectAll={handleSelectAll}
                            onEdit={handleEditAttendance}
                            onDelete={handleDeleteAttendance}
                            onSendSignatureInvitation={handleSendSignatureInvitation}
                            session={session}
                        />
                    ) : attendances.length > 0 ? (
                        <div className={styles.empty}>Aucune attendance ne correspond à votre recherche</div>
                    ) : (
                        <div className={styles.empty}>Aucune attendance trouvée pour cette session.</div>
                    )}
                </div>

            </Card>
        </>
    );
};

export default SignaturesAndAbsences;
